"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var deliverables_shared_service_1 = require("../deliverables-shared.service");
var deliverable_client_config_1 = require("../../deliverable.client.config");
var helpers_1 = require("../../helpers");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../../deliverable.client.config");
var ProfilesService = /** @class */ (function () {
    /**
     * Initialises a new instance of the ProfileService class.
     * @param http
     * @param config
     */
    function ProfilesService(http, config) {
        this.http = http;
        this.config = config;
    }
    /**
     * List CurrentActiveProjects
     * @param ownerId
     * @param teamId
     * @returns An Observable containing a list of SimpleDSingle
     */
    ProfilesService.prototype.ListCurrentActiveProjectsAsync = function (ownerId, teamId) {
        var params = new http_1.HttpParams();
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (teamId)
            params = params.set('teamId', teamId.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/profiles/currentwork", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List RecentlyCompletedProjects
     * @param ownerId
     * @param teamId
     * @returns An Observable containing a list of SimpleDSingle
     */
    ProfilesService.prototype.ListRecentlyCompletedProjectsAsync = function (ownerId, teamId) {
        var params = new http_1.HttpParams();
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (teamId)
            params = params.set('teamId', teamId.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/profiles/recentlycomplete", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
    * Get QueueWorkReadyStatusDistribution
    * @param ownerId
    * @param teamId
    * @returns An Observable containing DeliverableUnits
    */
    ProfilesService.prototype.GetQueueWorkReadyStatusDistributionAsync = function (ownerId, teamId) {
        var params = new http_1.HttpParams();
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (teamId)
            params = params.set('teamId', teamId.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/profiles/queuedistribution", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * Owners Availabilities In Days Async.
   * @param fromDate
   * @param toDate
   * @param unitType
   * @param ownerId
   * @param teamId
   * @param deliverableIdToExclude
   * @returns An Observable containing the Array<ProfileAvailabilityPerDay>
   */
    ProfilesService.prototype.AvailabilitiesInDaysAsync = function (fromDate, toDate, unitType, ownerId, teamId, removeDisabledProfilesWithoutWork, removeDisabledProfiles) {
        var params = new http_1.HttpParams();
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (unitType && unitType.id)
            params = params.set('unitType', unitType.id.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (teamId)
            params = params.set('teamId', teamId.toString());
        if (removeDisabledProfilesWithoutWork)
            params = params.set('removeDisabledProfilesWithoutWork', removeDisabledProfilesWithoutWork.toString());
        if (removeDisabledProfiles)
            params = params.set('removeDisabledProfiles', removeDisabledProfiles.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/profiles/AvailabilitiesInDays", { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * Teams whole availablility over a period of days
   * @param fromDate
   * @param toDate
   * @param unitType
   * @param teamId
   * @param deliverableIdToExclude
   * @returns An Observable containing the Array<ProfileAvailabilityPerDay>
   */
    ProfilesService.prototype.AvailabilitiesInDaysForWholeTeamAsync = function (fromDate, toDate, unitType, teamId, removeDisabledProfilesWithoutWork) {
        var params = new http_1.HttpParams();
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (unitType && unitType.id)
            params = params.set('unitType', unitType.id.toString());
        if (teamId)
            params = params.set('teamId', teamId.toString());
        if (removeDisabledProfilesWithoutWork)
            params = params.set('removeDisabledProfilesWithoutWork', removeDisabledProfilesWithoutWork.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/profiles/AvailabilitiesInDaysForWholeTeam", { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Owners Availabilities In Days Over A Period Async.
     * @param unitToFind
     * @param periodInDays
     * @param fromDate
     * @param toDate
     * @param unitType
     * @param ownerId
     * @param teamId
     * @param deliverableIdToExclude
     * @returns An Observable containing the Array<ProfileAvailabilityPerDayInPeriod>
     */
    ProfilesService.prototype.AvailabilitiesInDaysOverAPeriodAsync = function (unitToFind, periodInDays, fromDate, toDate, unitType, ownerId, teamId, deliverableIdToExclude, removeDisabledProfilesWithoutWork) {
        var params = new http_1.HttpParams();
        if (unitToFind)
            params = params.set('unitToFind', unitToFind.toString());
        if (periodInDays)
            params = params.set('periodInDays', periodInDays.toString());
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (unitType && unitType.id)
            params = params.set('unitType', unitType.id.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (teamId)
            params = params.set('teamId', teamId.toString());
        if (deliverableIdToExclude)
            params = params.set('deliverableIdToExclude', deliverableIdToExclude);
        if (removeDisabledProfilesWithoutWork)
            params = params.set('removeDisabledProfilesWithoutWork', removeDisabledProfilesWithoutWork.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/profiles/AvailabilitiesInDaysOverAPeriod", { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Availabilities In Days with Work Async.
     * @param fromDate
     * @param toDate
     * @param unitType
     * @param ownerId
     * @param teamId
     * @returns An Observable containing the Array<ProfileAvailablityPerDayWithWork>
     */
    ProfilesService.prototype.AvailabilitiesInDaysWithWorkAsync = function (fromDate, toDate, unitType, ownerId, teamId, hasUnits, ignoreSubteams, removeDisabledProfilesWithoutWork, workReadyStatuses) {
        var params = new http_1.HttpParams();
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (unitType && unitType.id)
            params = params.set('unitType', unitType.id);
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (teamId)
            params = params.set('teamId', teamId.toString());
        if (hasUnits)
            params = params.set('hasUnits', hasUnits.toString());
        if (ignoreSubteams)
            params = params.set('ignoreSubteams', ignoreSubteams.toString());
        if (removeDisabledProfilesWithoutWork)
            params = params.set('removeDisabledProfilesWithoutWork', removeDisabledProfilesWithoutWork.toString());
        if (workReadyStatuses)
            params = params.set('workReadyStatuses', workReadyStatuses);
        return this.http.get(this.config.DeliverablesApiURL + "/api/profiles/AvailabilitiesInDaysWithWork", { params: params })
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Owners Availabilities In Months Async.
     * @param fromDate
     * @param toDate
     * @param unitType
     * @param ownerId
     * @param teamId
     * @returns An Observable containing the Array<AvailabilityAggregateListPerMonth>
     */
    ProfilesService.prototype.AvailabilitiesInMonthsAsync = function (fromDate, toDate, unitType, ownerId, teamId, removeDisabledProfilesWithoutWork) {
        var params = new http_1.HttpParams();
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (unitType && unitType.id)
            params = params.set('unitType', unitType.id.toString());
        if (ownerId)
            params = params.set('ownerId', ownerId.toString());
        if (teamId)
            params = params.set('teamId', teamId.toString());
        if (removeDisabledProfilesWithoutWork)
            params = params.set('removeDisabledProfilesWithoutWork', removeDisabledProfilesWithoutWork.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/profiles/AvailabilitiesInMonths", { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * List total aggregate units in months sub group by Department, Work Ready Status, Contract Type or Feed
     * @param fromDate
     * @param toDate
     * @param subGroup
     * @param unitType
     * @param teamId
     * @returns An Observable containing the Array<MonthlyUnitsAggregate>
     */
    ProfilesService.prototype.TotalUnitsScopeInMonthsAsync = function (fromDate, toDate, subGroup, unitType, teamId) {
        var params = new http_1.HttpParams();
        if (fromDate)
            params = params.set('fromDate', fromDate);
        if (toDate)
            params = params.set('toDate', toDate);
        if (subGroup && subGroup.id)
            params = params.set('subGroup', subGroup.id.toString());
        if (unitType && unitType.id)
            params = params.set('unitType', unitType.id.toString());
        if (teamId)
            params = params.set('teamId', teamId.toString());
        return this.http.get(this.config.DeliverablesApiURL + "/api/profiles/totalunitsscopeinmonths", { params: params })
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    ProfilesService.ngInjectableDef = i0.defineInjectable({ factory: function ProfilesService_Factory() { return new ProfilesService(i0.inject(i1.HttpClient), i0.inject(i2.DELIVERABLE_CLIENT_CONFIG)); }, token: ProfilesService, providedIn: "root" });
    ProfilesService = __decorate([ __param(1, core_1.Inject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], ProfilesService);
ProfilesService.ɵfac = function ProfilesService_Factory(t) { return new (t || ProfilesService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)); };
ProfilesService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ProfilesService, factory: function (t) { return ProfilesService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProfilesService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG]
            }] }]; }, null); })();
    return ProfilesService;
}());
exports.ProfilesService = ProfilesService;

